module.exports = __webpack_public_path__ + "img/home-view-agents-logo.566ab677.png";